export default __webpack_public_path__ + "static/media/plantation_worker.bd825a8f.svg";